// extracted by mini-css-extract-plugin
export var cardIcon = "_m-5";
export var cardIconUnframed = "_m-9";
export var checkboxCard = "_m-0";
export var checkboxCardSelected = "_m-4";
export var disabled = "_m-2";
export var interactive = "_m-1";
export var outerBorder = "_m-3";
export var spacerMedium = "_m-8";
export var spacerSmall = "_m-7";
export var spacerXsmall = "_m-6";